<template>
    <div :class="classes">
        <template v-if="finalViewonly || finalReadonly">
            <span :class="prefixCls + '-text-content'">{{ textContent }}</span>
        </template>
        <template v-else>
            <slot></slot>    
        </template>
    </div>
</template>
<script>
    import { findComponentsDownward, oneOf } from '../../utils/assist';
    import Field from '../../mixins/field';

    const prefixCls = 'ivu-checkbox-group';

    export default {
        name: 'CheckboxGroup',
        mixins: [ Field ],
        composed: true,
        props: {
            value: {
                type: Array,
                default () {
                    return [];
                }
            },
            size: {
                validator (value) {
                    return oneOf(value, ['small', 'large', 'default']);
                },
                default () {
                    return !this.$IVIEW || this.$IVIEW.size === '' ? 'default' : this.$IVIEW.size;
                }
            },
        },
        data () {
            return {
                currentValue: this.value,
                childrens: [],
            };
        },
        computed: {
            prefixCls(){
                return prefixCls
            },
            classes () {
                return [
                    `${prefixCls}`,
                    {
                        [`ivu-checkbox-${this.size}`]: !!this.size
                    }
                ];
            },
            textContent(){
                return this.childrens
                    .filter(v => Boolean(v.currentValue)).map(v => v.$el.textContent.trim()).join(",")
            },
        },
        mounted () {
            this.updateCheckedItems(true);
        },
        methods: {
            updateCheckedItems (update) {
                this.childrens = findComponentsDownward(this, 'Checkbox');

                if (this.childrens) {
                    const { value } = this;

                    this.childrens.forEach(child => {
                        child.checkedItems = value;

                        if (update) {
                            child.currentValue = value.indexOf(child.label) >= 0;
                            child.group = true;
                        }
                    })
                }
            },

            change (data, target) {
                this.currentValue = data;
                this.$emit('input', data);
                this.$emit('on-change', data, target);
                this.dispatchFormChange(data);
            },
        },
        watch: {
            value () {
                this.updateCheckedItems(true);
            }
        }
    };
</script>
